export default "__VITE_ASSET__DtVRwwLx__"